module.exports = __webpack_public_path__ + "static/media/75.b63c75f5.png";